import { render, staticRenderFns } from "./formSkeleton.vue?vue&type=template&id=62761b7d&scoped=true"
import script from "./formSkeleton.vue?vue&type=script&lang=js"
export * from "./formSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_babel-core@6.26.3_cache-loader@4.1.0_css-loader@3.6_es6nbxkbffq4rffv33bwkugdri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62761b7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bluetooth-light-web\\node_modules\\.pnpm\\registry.npmmirror.com+vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62761b7d')) {
      api.createRecord('62761b7d', component.options)
    } else {
      api.reload('62761b7d', component.options)
    }
    module.hot.accept("./formSkeleton.vue?vue&type=template&id=62761b7d&scoped=true", function () {
      api.rerender('62761b7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/business/Form/formSkeleton.vue"
export default component.exports